import { CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';

@Component({
  selector: 'app-custom-select',
  templateUrl: './custom-select.component.html',
  styleUrls: ['./custom-select.component.scss'],
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomSelectComponent),
      multi: true
    }
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, SelectModule, TableModule]
})
export class CustomSelectComponent implements ControlValueAccessor, OnChanges {

  onChange = (value: any) => { value };
  onTouched = () => { };
  selectedValue: CustomListDropdown | null = null;

  @Input() disabled: boolean = false;
  @Input() internalValue: any = null;
  @Input() inputClass: string = '';
  @Input() labelText: string = "";
  @Input() list: CustomListDropdown[] = [];
  @Input() recovery: boolean = false;
  @Input() required: boolean = false;
  @Input() showClear: boolean = false;
  @Output() onChangeSelect = new EventEmitter<number>();


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['list'] && this.internalValue !== null) {
      this.updateSelectedValue();
    }
  }

  changeSelected(event: any) {
    this.selectedValue = event.value;
    this.internalValue = event.value?.value ?? null;
    this.onChange(this.internalValue);
    this.onTouched();
    this.onChangeSelect.emit(this.internalValue);
  }

  updateSelectedValue(): void {
    if (this.list?.length) {
      this.selectedValue = this.list.find(item => item.value === this.internalValue) || null;
    } else {
      this.selectedValue = null;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(value: any): void {
    this.internalValue = value;
    this.updateSelectedValue();
  }

}
